export default __webpack_public_path__ + "static/media/active_ip.d80a34f5.svg";